import { useState } from "react";
import { useCartSelector } from "../pages/cartSelectorContext";
import { FaCartPlus } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";

const ProductCard = ({ product }) => {
 const { openCartSelector } = useCartSelector();
 const [quantity,setQuantity] = useState(1)

//  console.log("Product:",product)

 const {name} = useParams()
 const navigate = useNavigate()

    return (
        <div className="" onClick={()=>navigate(`/b/${name}/products/${product._id}`,{state:{product}})}>
            <div className="user-product-card">
                <div className="user-product-img">
                    <img src={product?.files?.[0]?.url} alt={product.title} />
                    <button className="user-product-cart-btn">
                        <FaCartPlus onClick={()=>openCartSelector(product._id,quantity,name)}/>
                    </button>
                </div>
                <div className="user-product-details">
                    <div className="user-product-detail-header">
                        <h2>{product.title}</h2>
                        <p className="user-product-price">${product.price}</p>
                    </div>
                    <p className="user-product-description">{product.description}</p>
                </div>
            </div>
        </div>
    );
};

export default ProductCard;